export default __webpack_public_path__ + "static/media/company-logo.12a648ee.png";